/*
 * filtres sav
 */
if( $('#filters_sav').get().length ) {

	//
	// champ lot + corps_etat dynamiques selon le champ programme
	$('#filters_sav_programme').on('changed.bs.select', function() {
		var $this = $(this);
		// lot
		var options = $('option:selected', $this).data('options');
		var options_str = '';
		for( var i = 0; i < options.length; i++ )
			options_str += '<option value="' + options[i].id + '">' + options[i].label + '</option>';
		$('#filters_sav_lot').html(options_str).selectpicker('refresh');
	});

	// actions groupées
	/*$('.selectmulti').on('change', function() {
		var selected = [];
		$('.selectmulti:checked').each(function() {
			selected.push($(this).val());
		});
		$('#frm_sav_actionsgroupees_ids').val(JSON.stringify(selected));
		if ( selected.length ) {
			$('#frm_sav_actionsgroupees').addClass('active');
		} else {
			$('#frm_sav_actionsgroupees').removeClass('active');
		}
	});*/
	// selection multiple
	const selectall = document.querySelector('[data-selectall]');
	if ( selectall ) {
		selectall.addEventListener('change', function(e) {
			document.querySelectorAll('[data-select]').forEach(function(row) {
				row.checked = selectall.checked;
				row.dispatchEvent(new MouseEvent('change'));
			});
		});
	}

	// selection multiple
	document.querySelectorAll('[data-select]').forEach(function(select) {
		select.addEventListener('click', function(e) {
			e.stopPropagation();
			if ( select.checked && e.shiftKey ) {
				const selects = Array.prototype.slice.call(document.querySelectorAll('[data-select]'));
				let firstIndex = selects.indexOf(document.querySelector('[data-select]:checked'));
				let index = selects.indexOf(select);
				if ( firstIndex == index ) {
					index = selects.indexOf(Array.prototype.slice.call(document.querySelectorAll('[data-select]:checked')).pop());
				}
				for ( let i = firstIndex; i <= index; i++ ) {
					selects[i].checked = true;
					selects[i].dispatchEvent(new MouseEvent('change'));
				}
			} else {
				select.dispatchEvent(new MouseEvent('change'));
			}
		});
		select.addEventListener('change', function(e) {
			if ( select.checked )
				select.closest('tr').classList.add('table-info');
			else
				select.closest('tr').classList.remove('table-info');
			let selected = [];
			document.querySelectorAll('[data-select]:checked').forEach(function(el) {
				selected.push(el.value);
			});
			document.getElementById('frm_sav_actionsgroupees_ids').value = JSON.stringify(selected);
			if ( selected.length ) {
				document.getElementById('frm_sav_actionsgroupees').classList.add('active');
			} else {
				document.getElementById('frm_sav_actionsgroupees').classList.add('active');
			}
		});
	});

}


/*
 * fonctions spécifiques au formulaire de sav
 */
if( $('#frm_sav').get().length ) {

	//
	// champ lot + corps_etat dynamiques selon le champ programme
	$('#frm_sav_programme').on('changed.bs.select', function() {
		var $this = $(this);
		// lot
		var options = $('option:selected', $this).data('options');
		var options_str = '';
		if( options.length ) {
			for( var i = 0; i < options.length; i++ )
				options_str += '<option value="' + options[i].id + '" data-client="' + options[i].client + '">' + options[i].label + '</option>';
			$('#cont_frm_sav_lot').removeClass('d-none');
			$('#cont_frm_sav_lot_message').addClass('d-none');
		}
		else {
			$('#cont_frm_sav_lot').addClass('d-none');
			$('#cont_frm_sav_lot_message').removeClass('d-none');
		}
		$('#frm_sav_lot').html(options_str).selectpicker('refresh');

		// client
		options_str = '';
		if( options.length ) {
			for( var i = 0; i < options.length; i++ )
				options_str += '<option value="' + options[i].client + '" data-lot="' + options[i].id + '">' + options[i].client_nom + '</option>';
			$('#cont_frm_sav_client').removeClass('d-none');
			$('#cont_frm_sav_client_message').addClass('d-none');
		}
		else {
			$('#cont_frm_sav_client').addClass('d-none');
			$('#cont_frm_sav_client_message').removeClass('d-none');
		}
		$('#frm_sav_client').html(options_str).selectpicker('refresh');

		// corps_etat
		var options = $('option:selected', $this).data('fournisseurs');
		var options_str = '';
		if( options.length ) {
			for( var i = 0; i < options.length; i++ )
				options_str += '<option value="' + options[i].id + '" data-fournisseur="' + JSON.stringify(options[i]).replace(/"/g, '&quot;') + '">' + options[i].categorie_label + ' - ' + options[i].nom + '</option>';
		}
		$('#frm_sav_corps_etat').html(options_str).selectpicker('refresh');

		$('#cont_frm_sav_fournisseur').addClass('d-none');
	});

	// affichage client selon lot sélectionné
	$('#frm_sav_lot').on('changed.bs.select', function() {
		if( $('#frm_sav_lot').val() != '' ) {
			$('#frm_sav_client').val($('#frm_sav_lot option:selected').data('client')).selectpicker('refresh');
		}
		else
			$('#frm_sav_client').val('').selectpicker('refresh');
	});

	// affichage lot selon client sélectionné
	$('#frm_sav_client').on('changed.bs.select', function() {
		if( $('#frm_sav_client').val() != '' ) {
			$('#frm_sav_lot').val($('#frm_sav_client option:selected').data('lot')).selectpicker('refresh');
		}
		else
			$('#frm_sav_lot').val('').selectpicker('refresh');
	});

	// affichage fournisseur selon lot fournisseur
	$('#frm_sav_corps_etat').on('changed.bs.select', function() {
		if( $('#frm_sav_corps_etat').val() != '' ) {
			var options = $('#frm_sav_corps_etat option:selected').data('fournisseur');
			$('#frm_sav_corps_etat_categorie').val(options['categorie']);
			var values = ['nom', 'categorie_label', 'nom_responsable_sav', 'email', 'email2', 'telephone', 'telephone2', 'adresse'];
			for( var i = 0; i < values.length; i++ ) {
				$('#cont_frm_sav_fournisseur_' + values[i]).val(options[values[i]]);
			}
			$('#cont_frm_sav_fournisseur').removeClass('d-none');
		}
		else {
			$('#cont_frm_sav_fournisseur').addClass('d-none');
			$('#frm_sav_corps_etat_categorie').val('');
		}
	});


	// champs selon le champ type
	$('#frm_sav_type').on('change', function() {
		var $this = $(this);
		var val = $('#frm_sav_type').val();
		$('.field_type:not(.field_' + val + ')').addClass('d-none');
		$('.field_type.field_' + val).removeClass('d-none');
	});

	/*
	$('#frm_sav_assureur_prise_en_charge').on('change', function() {
		var $this = $(this);
		if( $this.prop('checked') )
			$('#field_date_assureur_prise_en_charge').removeClass('d-none');
		else
			$('#field_date_assureur_prise_en_charge').addClass('d-none');
	});

	$('#frm_sav_proposition_indemnite').on('change', function() {
		var $this = $(this);
		if( $this.prop('checked') )
			$('#field_date_proposition_indemnite').removeClass('d-none');
		else
			$('#field_date_proposition_indemnite').addClass('d-none');
	});
	*/

	$('input[name="proprietaire_demandeur"]').on('change', function() {
		if( $('#frm_sav_proprietaire_demandeurAXANIS').prop('checked') )
			$('#field_proprietaire_demandeur_AXANIS').removeClass('d-none');
		else
			$('#field_proprietaire_demandeur_AXANIS').addClass('d-none');
	});

	/*
	// délais par rapport au champ date_reception_courrier
	$('#frm_sav_date_reception_courrier').on('change', function() {
		var $this = $(this);
		var m = $this.val().match(/^\s*(\d+)\/(\d+)\/(\d+)\s*$/);
		if( m !== null ) {
			var year = parseInt(m[3]);
			var month = parseInt(m[2]) - 1;
			var day = parseInt(m[1]);

			// delai prise en charge assureur 60 j
			var d = new Date(year, month, day + 60);
			var year1 = d.getFullYear();
			var month1 = d.getMonth() + 1;
			if( month1 < 10 )
				month1 = '0' + month1;
			var day1 = d.getDate();
			if( day1 < 10 )
				day1 = '0' + day1;
			$('#delai_prise_en_charge_assureur').html( '(Date limite : ' + day1 + '/' + month1 + '/' + year1 + ')' );

			// delai proposition indemnité 90 j
			var d = new Date(year, month, day + 90);
			var year1 = d.getFullYear();
			var month1 = d.getMonth() + 1;
			if( month1 < 10 )
				month1 = '0' + month1;
			var day1 = d.getDate();
			if( day1 < 10 )
				day1 = '0' + day1;
			$('#delai_proposition_indemnite').html( '(Date limite : ' + day1 + '/' + month1 + '/' + year1 + ')' );
		}
		else {
			$('#delai_prise_en_charge_assureur').html('');
			$('#delai_proposition_indemnite').html('');
		}
	});
	*/
	
	// délais par rapport au champ date_reception_courrier
	$('#frm_sav_date_declaration').on('input', function() {
		var $this = $(this);
		var m = $this.val().match(/^\s*(\d+)\/(\d+)\/(\d+)\s*$/);
		if( m !== null ) {
			var year = parseInt(m[3]);
			var month = parseInt(m[2]) - 1;
			var day = parseInt(m[1]);

			// delai_ar_assureur 10j
			var d = new Date(year, month, day + 10);
			var year1 = d.getFullYear();
			var month1 = d.getMonth() + 1;
			if( month1 < 10 )
				month1 = '0' + month1;
			var day1 = d.getDate();
			if( day1 < 10 )
				day1 = '0' + day1;
			$('#delai_ar_assureur').html( 'Date limite : ' + day1 + '/' + month1 + '/' + year1 );

		}
		else {
			$('#delai_ar_assureur').html('');
		}
	});

	// délais par rapport au champ do_date_ar_assureur
	$('#frm_sav_do_date_ar_assureur').on('input', function() {
		var $this = $(this);
		var m = $this.val().match(/^\s*(\d+)\/(\d+)\/(\d+)\s*$/);
		if( m !== null ) {
			var year = parseInt(m[3]);
			var month = parseInt(m[2]) - 1;
			var day = parseInt(m[1]);

			// delai_reponse_assureur 15j
			var d = new Date(year, month, day + 15);
			var year1 = d.getFullYear();
			var month1 = d.getMonth() + 1;
			if( month1 < 10 )
				month1 = '0' + month1;
			var day1 = d.getDate();
			if( day1 < 10 )
				day1 = '0' + day1;
			$('#delai_reponse_assureur').html( 'Date limite : ' + day1 + '/' + month1 + '/' + year1 );

		}
		else {
			$('#delai_reponse_assureur').html('');
		}
	});

	// do_ar_assureur
	$('#frm_sav_do_ar_assureur').on('change', function() {
		if( $(this).prop('checked') ) {
			$('#zone_do_date_ar_assureur').removeClass('d-none');
			$('#frm_sav_do_date_ar_assureur').prop('required', true);
			$('#zone_do_reponse_assureur').removeClass('d-none');
		}
		else {
			$('#zone_do_date_ar_assureur').addClass('d-none');
			$('#frm_sav_do_date_ar_assureur').prop('required', false);
			$('#zone_do_reponse_assureur').addClass('d-none');
		}
		$('#frm_sav_do_date_ar_assureur').trigger('input');
		$('html,body').animate({ scrollTop: $('#wrapper').height() - $(window).height() }, 250);
	});

	// do_assureur_prise_en_charge
	$('#frm_sav_do_assureur_prise_en_charge-oui, #frm_sav_do_assureur_prise_en_charge-non').on('change', function() {
		if( $('#frm_sav_do_assureur_prise_en_charge-oui').prop('checked') ) {
			$('#zone_do_expertise').removeClass('d-none');
		}
		else {
			$('#zone_do_expertise').addClass('d-none');
			$('input[name="do_expertise_immediate"]').prop('checked', false).trigger('change');
		}
		$('html,body').animate({ scrollTop: $('#wrapper').height() - $(window).height() }, 250);
	});

	// do_expertise_immediate
	$('#frm_sav_do_expertise_immediate-oui, #frm_sav_do_expertise_immediate-non').on('change', function() {
		$('#zone_do_expertise_date').removeClass('d-none');
		$('#frm_sav_do_expertise_date').prop('required', true);
		if( $('#frm_sav_do_expertise_immediate-oui').prop('checked') ) {
			$('#zone_do_expertise_immediate').removeClass('d-none');
			$('#zone_do_expertise_report').addClass('d-none');
		}
		else if( $('#frm_sav_do_expertise_immediate-non').prop('checked') ) {
			$('#zone_do_expertise_immediate').addClass('d-none');
			$('#zone_do_expertise_report').removeClass('d-none');
		}
		else {
			$('#zone_do_expertise_date').addClass('d-none');
			$('#frm_sav_do_expertise_date').prop('required', false);
			$('#zone_do_expertise_immediate').addClass('d-none');
			$('#zone_do_expertise_report').addClass('d-none');
		}
		$('html,body').animate({ scrollTop: $('#wrapper').height() - $(window).height() }, 250);
	});

	// délais par rapport au champ do_expertise_date
	$('#frm_sav_do_expertise_date').on('input', function() {
		var $this = $(this);
		var m = $this.val().match(/^\s*(\d+)\/(\d+)\/(\d+)\s*$/);
		if( m !== null ) {
			var year = parseInt(m[3]);
			var month = parseInt(m[2]) - 1;
			var day = parseInt(m[1]);

			// delai_reponse_garantie 60j
			var d = new Date(year, month, day + 60);
			var year1 = d.getFullYear();
			var month1 = d.getMonth() + 1;
			if( month1 < 10 )
				month1 = '0' + month1;
			var day1 = d.getDate();
			if( day1 < 10 )
				day1 = '0' + day1;
			$('#delai_reponse_garantie').html( 'Date limite : ' + day1 + '/' + month1 + '/' + year1 );

			// delai_proposition_indemnisation 30j
			var d = new Date(year, month, day + 30);
			var year1 = d.getFullYear();
			var month1 = d.getMonth() + 1;
			if( month1 < 10 )
				month1 = '0' + month1;
			var day1 = d.getDate();
			if( day1 < 10 )
				day1 = '0' + day1;
			$('#delai_proposition_indemnisation').html( 'Date limite : ' + day1 + '/' + month1 + '/' + year1 );

		}
		else {
			$('#delai_reponse_garantie').html('');
			$('#delai_proposition_indemnisation').html('');
		}
	});


	// annulation -> show msg
	/*$('#frm_sav_annulation').on('change', function() {
		if( $(this).val() == '' )
			$('#annulation_msg').addClass('d-none');
		else
			$('#annulation_msg').removeClass('d-none');
	});*/


	// mise en demeure
	$('#frm_sav_date_mise_en_demeure').on('change', function() {
		if( $(this).prop('checked') ) {
			$('.zone_med1').removeClass('d-none');
		}
		else {
			$('.zone_med1').addClass('d-none');
		}
		$('html,body').animate({ scrollTop: $('#wrapper').height() - $(window).height() }, 250);
	});
	$('#frm_sav_date_mise_en_demeure2').on('change', function() {
		if( $(this).prop('checked') ) {
			$('.zone_med2').removeClass('d-none');
		}
		else {
			$('.zone_med2').addClass('d-none');
		}
		$('html,body').animate({ scrollTop: $('#wrapper').height() - $(window).height() }, 250);
	});

	$('#frm_sav_date_declaration').on('change', function() {
		if ( $(this).val().length == 10 ) {
			let date = new Date( $(this).val().substring(6, 10) + '-' + $(this).val().substring(3, 5) + '-' + $(this).val().substring(0, 2) );
			date.setDate(date.getDate() + 15);
			let str = '';
			let t = date.getDate();
			if ( t < 10 ) {
				str += '0';
			}
			str += t.toString();
			str += '/';
			t = date.getMonth() + 1;
			if ( t < 10 ) {
				str += '0';
			}
			str += t.toString();
			str += '/';
			str += date.getFullYear().toString();
			$('#frm_sav_date_faisabilite').val(str);
		}
	});

}


//
// sendmail différé
$('.frm_sav_sendmail').on('submit', function(e) {
	e.preventDefault();
	var $form = $(this);
	$.ajax({
		type: "POST",
		data: { action: 'sendmail', mail: $('textarea', $form).val() },
		dataType: 'json'
	});
	$form.after('<div class="mt-2"><strong>Mail envoyé</strong></div>');
	$form.remove();
});


//
// Mise en demeure
$('#frm_med').on('submit', function(e) {
	e.preventDefault();
	var $form = $(this);
	var action = $('input[name="action"]', $form).val();
	if ( action == 'generatemed' ) {
		$.ajax({
			type: "POST",
			data: { action: action, suivi: $('textarea', $form).val() },
		}).done(function(data) {
			$('.modal-body', $form).html(data);
			$('input[name="action"]', $form).val('sendmed');
			$('button[type="submit"]', $form).text('Envoyer');
		});
	} else if ( action == 'sendmed' ) {
		$.ajax({
			type: "POST",
			data: { action: 'sendmail', mail: $('textarea', $form).val() },
			dataType: 'json'
		}).done(function(data) {
			$('.modal-body', $form).html('<strong class="text-success">Mail envoyé</strong>');
			$('.modal-footer', $form).remove();
			$.ajax({
				type: "POST",
				data: { action: 'refreshenvois' },
			}).done(function(data) {
				$('#envois_inner').html(data);
			});
		});
	}
});